var _defs, _circle, _circle2, _g, _circle3, _circle4, _path, _polygon, _polygon2, _path2, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHitKuzel10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ring",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffb066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#e8391b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#96190a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "face",
    cx: 0.35,
    cy: 0.28,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffcfb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#ffffff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 97,
    fill: "url(#ring)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 97,
    fill: "none",
    stroke: "#96190a",
    strokeWidth: 2.5,
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffb066",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186.3,
    cy: 117.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.2,
    cy: 148.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 173.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 186.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8,
    cy: 186.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 173.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 148.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 117.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 82.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 51.1,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 26.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8,
    cy: 13.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 13.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 26.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.2,
    cy: 51.1,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.3,
    cy: 82.8,
    r: 3.1
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 79,
    fill: "url(#face)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 79,
    fill: "none",
    stroke: "#96190a",
    strokeWidth: 2,
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21 100 A 79 79 0 0 1 179 100 Z",
    fill: "url(#gloss)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "89.5,24.5 91.7,29.9 97.6,30.4 93.1,34.2 94.5,39.9 89.5,36.8 84.5,39.9 85.9,34.2 81.4,30.4 87.3,29.9",
    fill: "#96190a",
    stroke: "#ffb066",
    strokeWidth: 1.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.5,24.5 112.7,29.9 118.6,30.4 114.1,34.2 115.5,39.9 110.5,36.8 105.5,39.9 106.9,34.2 102.4,30.4 108.3,29.9",
    fill: "#96190a",
    stroke: "#ffb066",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(100,100) scale(1.14)",
    d: "M 0 34 C -30 12 -44 -2 -44 -20 C -44 -35 -33 -44 -21 -44 C -11 -44 -4 -38 0 -31 C 4 -38 11 -44 21 -44 C 33 -44 44 -35 44 -20 C 44 -2 30 12 0 34 Z",
    fill: "#c2160f",
    stroke: "#7a0b07",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,106) scale(0.54)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 31,
    rx: 43,
    ry: 9.5,
    fill: "#c05f00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 29,
    rx: 43,
    ry: 9.5,
    fill: "#e07f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -34 29 L -8.5 -46 Q 0 -52.5 8.5 -46 L 34 29 Z",
    fill: "#ff9911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -50.6 L 8.5 -46 L 34 29 L 0 29 Z",
    fill: "#e07f00",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -21.7 -6 L 21.7 -6 L 26.5 8 L -26.5 8 Z",
    fill: "#f4f4f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -6 L 21.7 -6 L 26.5 8 L 0 8 Z",
    fill: "#d9d9de",
    opacity: 0.55
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 143,
    width: 56,
    height: 38,
    rx: 19,
    fill: "#96190a",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 145,
    width: 52,
    height: 34,
    rx: 17,
    fill: "none",
    stroke: "#ffb066",
    strokeWidth: 1.6,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 172,
    textAnchor: "middle",
    fontFamily: "Arial Black, Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    fill: "#ffffff",
    letterSpacing: 0.5
  }, "10"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitKuzel10);
export default __webpack_public_path__ + "static/media/hit-kuzel-10.2cbdd9f4935d522f0b5000b53c71e8b4.svg";
export { ForwardRef as ReactComponent };